import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import DocumentTextIcon from '@heroicons/react/outline/DocumentTextIcon';
import { useRouter } from '@tribeplatform/react-sdk';
import { useSearch } from '@tribeplatform/react-sdk/hooks';
import { getSearchKey } from '@tribeplatform/react-sdk/utils/keys';
import { FormControl } from '@tribeplatform/react-ui-kit/FormControl';
import { ExternalLinkIcon } from '@tribeplatform/react-ui-kit/icons';
import { List } from '@tribeplatform/react-ui-kit/Layout';
import { useDebounce } from '../common/hooks/useDebounce';
import { T } from '../i18n';
import { getSearchItemLink } from '../Search/utils';
import { cleanSearchQuery } from '../utils/search';
export const SimilarPosts = ({ query: dirtyQuery, spaceId = null }) => {
    var _a, _b, _c;
    const query = cleanSearchQuery(dirtyQuery);
    const debouncedQuery = useDebounce(query, 100);
    const { Link } = useRouter();
    const generatedQuery = `${query} +for:post ${spaceId ? `+in:${spaceId}` : ''}`;
    const { data: searchData } = useSearch({
        variables: {
            input: {
                query: generatedQuery,
            },
        },
        fields: { in: 'basic' },
        useQueryOptions: {
            queryKey: getSearchKey({
                variables: {
                    input: { query: generatedQuery },
                },
            }),
            keepPreviousData: true,
            enabled: !!debouncedQuery,
        },
    });
    if (!query) {
        return null;
    }
    const posts = ((_b = (_a = searchData === null || searchData === void 0 ? void 0 : searchData.hits) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.hits) || [];
    if (!(posts === null || posts === void 0 ? void 0 : posts.length)) {
        return null;
    }
    return (_jsxs(FormControl, { children: [_jsx(FormControl.Label, { children: _jsx(T, { id: "Post.SimilarPosts.SectionTitle", defaultMessage: "Similar posts" }, void 0) }, void 0), _jsx(List, { className: "border border-line-subdued rounded-md", spacing: "none", children: (_c = [...posts]) === null || _c === void 0 ? void 0 : _c.splice(0, 7).map(post => (_jsx(List.Item, { children: _jsxs(Link, { className: "p-3 space-s-3 border-md flex items-center hover:bg-surface-hovered", variant: "neutral", target: "_blank", href: getSearchItemLink(post), children: [_jsx(DocumentTextIcon, { className: "w-5 h-5" }, void 0), _jsx("span", { className: "flex-1 truncate", children: post === null || post === void 0 ? void 0 : post.title }, void 0), _jsx(ExternalLinkIcon, { className: "w-4 h-4" }, void 0)] }, void 0) }, post === null || post === void 0 ? void 0 : post.entityId))) }, void 0)] }, void 0));
};
//# sourceMappingURL=SimilarPosts.js.map